<template>
  <div :class="additionalClass" class="checkbox">
    <label>
      <input
        :checked="checked"
        :name="name"
        :value="modelValue"
        type="checkbox"
        @click="preventIfDisabled"
        @change="change"
      />
      <i class="input-helper" />
      &nbsp;
      <span :v-tooltip:top="tooltip">
        <slot />
      </span>
    </label>
  </div>
</template>

<script>
import { convertToPrimitive } from '@/utils/tools'

export default {
  props: {
    checked: { type: Boolean, default: false },
    name: { type: String, required: true },
    modelValue: { type: [Number, String, Boolean], default: 1 },
    tooltip: { type: String, default: '' },
    additionalClass: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  emits: ['touched', 'change', 'input', 'update:modelValue'],
  methods: {
    change(e) {
      this.$emit('touched')
      this.$emit('change', e.target.value, e.target.checked)
      this.$emit('update:modelValue', convertToPrimitive(e.target.checked, this.modelValue))
    },
    preventIfDisabled(e) {
      if (this.disabled) {
        e.preventDefault()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.checkbox {
  margin: 4px 0;
  @media (min-width: 768px) {
    margin: 0;
  }
}
</style>
